// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604220803/js/" + chunkId + "." + {"44":"d015a68b","225":"71569867","481":"5a9734cb","486":"a5191e3d","770":"bb9f40d9"}[chunkId] + ".0.0009620228579036993.chunk.js";
};